import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CTASectionProps {
  isAuthenticated: boolean;
  activeRole?: string | null;
}

const CTASection = ({ isAuthenticated, activeRole }: CTASectionProps) => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (isAuthenticated && activeRole) {
      navigate(`/${activeRole.toLowerCase()}`);
    } else {
      navigate("/register");
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-primary rounded-2xl p-12 text-center text-white">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Ready to Transform Your Store Management?
        </h2>
        <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
          Join thousands of businesses using StorePilot to streamline their operations and grow their revenue.
        </p>
        <button
          onClick={handleGetStarted}
          className="bg-white text-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition transform hover:scale-105 shadow-lg flex items-center gap-2 mx-auto"
        >
          {isAuthenticated ? "Go to Dashboard" : "Get Started"}
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
};

export default CTASection;

